import React  from 'react'
import DropDown from '../dropdown';
import  {useTextResources} from '../../../language';



const ReservationTypesDropDown = ({...props}) => {
    const text = useTextResources()
    const types = [
        {
          Id: 0, Name: text("Individuals")
        },
        {
            Id: 1, Name: text("GroupMaster")
        },
        {
            Id: 2, Name: text("GroupMembers")
        }        
    ]
    return <DropDown search={false} data={types} textField="Name" valueField="Id"  {...props}/>
}

export default ReservationTypesDropDown